import type { LucideIcon } from "lucide-react";
import type { QuickAddTone } from "../QuickAddBar/QuickAddBar";

const toneClasses: Record<QuickAddTone, string> = {
  brand: "bg-brand text-surface hover:bg-brand-muted",
  revenue: "bg-revenue text-white hover:bg-revenue-muted",
  expense: "bg-expense text-white hover:bg-expense-muted",
  focus: "bg-focus text-white hover:bg-focus/90",
  neutral: "bg-surface-elevated text-white ring-1 ring-white/10 hover:bg-white/10",
};

interface LabeledFabActionProps {
  label: string;
  icon: LucideIcon;
  onClick: () => void;
  tone?: QuickAddTone;
  badge?: string;
}

export function LabeledFabAction({
  label,
  icon: Icon,
  onClick,
  tone = "neutral",
  badge,
}: LabeledFabActionProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center justify-end gap-2"
    >
      <span className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-surface-elevated px-3 py-1.5 text-xs font-semibold text-white/90 shadow-sm ring-1 ring-white/10">
        {label}
        {badge ? (
          <span className="rounded-full bg-brand/20 px-1.5 py-0.5 text-[10px] font-black uppercase tracking-wide text-brand">
            {badge}
          </span>
        ) : null}
      </span>
      <span
        className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-full shadow-glow ring-1 ring-white/10 transition-transform hover:scale-105 ${toneClasses[tone]}`}
      >
        <Icon className="h-5 w-5" />
      </span>
    </button>
  );
}
